import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicAPIServices from '../../../services/publicAPIServices';

const initialState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  message: ''
};

//fetch all data

export const fetchRoomsFilteredData = createAsyncThunk('roomsFiltered/fetch', async (url, thunkAPI) => {
  try {
    return await publicAPIServices.fetchData(url);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


export const roomFilteredSlice = createSlice({
  name: 'roomsFiltered',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomsFilteredData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoomsFilteredData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchRoomsFilteredData.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.data = null;
      })
     
  }
});

export const { reset } = roomFilteredSlice.actions;
export default roomFilteredSlice.reducer;
